import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <circle data-name="Ellipse 420" cx="26.5" cy="26.5" r="26.5" opacity={0.25} />
      <path
        data-name="Path 1306"
        d="M16.031 3.9c.013-.613-.01-1-.01-1H3.979s-.023.387-.01 1H0v.654c0 .149.025 3.673 2.2 5.6a4.915 4.915 0 0 0 3.373 1.216c.2 0 .409-.014.62-.032a5.79 5.79 0 0 0 2.618 2.127v2.875H5.92v1.8h-.956v1.01h10.072v-1.009h-.956v-1.8h-2.891v-2.875a5.793 5.793 0 0 0 2.618-2.127c.211.018.419.031.621.031a4.915 4.915 0 0 0 3.372-1.211c2.175-1.93 2.2-5.454 2.2-5.6V3.9zM3.073 9.184a6.393 6.393 0 0 1-1.718-3.973h2.689a13.087 13.087 0 0 0 1 4.129c.113.248.232.484.354.714a3.608 3.608 0 0 1-2.325-.87zm13.854 0a3.6 3.6 0 0 1-2.323.87c.122-.23.241-.466.354-.714a13.068 13.068 0 0 0 1-4.129h2.689a6.392 6.392 0 0 1-1.72 3.973z"
        // style="fill:#187ae8"
        transform="translate(16.5 15.477)"
      />
    </svg>
  )
}

type EventsIconRoundedProps = SvgIconProps

export const EventsIconRounded: React.FC<EventsIconRoundedProps> = (props) => {
  return <SvgIcon {...props} viewBox="-1 -1 55 55" focusable="false" aria-hidden="true" />
}
